var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiPie',{attrs:{"values":_vm.values,"colors":_vm.colors,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }